export const fliterErr500 = [
  '/test/pub/token',
  '/v1/api/ad/clickRate-Web'
]


// WEBPACK FOOTER //
// ./src/axios/fliters.js